/*
 * Church search — unified single-field search
 */
import { getUrlParameter, isValidPostcode, sendEvent } from "./global.js";

let map;
let xhr;
let markerCluster;
let infowindow;
const global_markers = [];
const global_markers_data = [];
const infowindows = [];
let newlistings = [];
let search_url = "";
let centerCoords;
let zoomLevel;
let previousCenterCoords;
let previousZoomLevel;

const PIN_SVG =
	"M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";

let search_icon;
let search_icon_hover;

(function ($) {
	if (!$("body.find-a-church").length) return;

	async function initMap() {
		const { Map } = await google.maps.importLibrary("maps");

		search_icon = {
			path: PIN_SVG,
			anchor: new google.maps.Point(12, 17),
			fillOpacity: 1,
			fillColor: "#2bb2bc",
			strokeWeight: 1,
			strokeColor: "#1c9da0",
			scale: 2,
		};
		search_icon_hover = {
			path: PIN_SVG,
			anchor: new google.maps.Point(12, 17),
			fillOpacity: 1,
			fillColor: "#3c4981",
			strokeWeight: 1,
			strokeColor: "#2e3d6b",
			scale: 2,
		};

		// Read URL params (backward compat for old URLs + new unified param)
		const url_lat = parseFloat(getUrlParameter("search_lat"));
		const url_lon = parseFloat(getUrlParameter("search_lon"));
		const url_place = decodeURIComponent(getUrlParameter("search_place") || "");
		const url_name = decodeURIComponent(getUrlParameter("search_name") || "");
		const url_search = decodeURIComponent(getUrlParameter("search") || "");

		const map_center = {
			lat: url_lat || 53.76293458756777,
			lng: url_lon || -2.1087462927010394,
		};
		const map_zoom = 6;

		map = new Map(document.getElementById("map"), {
			center: map_center,
			zoom: map_zoom,
			mapId: "10c54dda61bbc61b",
		});

		previousZoomLevel = map_zoom;
		zoomLevel = map_zoom;
		previousCenterCoords = map_center;
		centerCoords = map_center;

		map.addListener("center_changed", function () {
			centerCoords = map.getCenter();
		});
		map.addListener("zoom_changed", function () {
			zoomLevel = map.getZoom();
		});

		// Google Places Autocomplete on unified input
		const searchInput = document.getElementById("church_search");
		const autocomplete = new google.maps.places.Autocomplete(searchInput);
		autocomplete.setComponentRestrictions({ country: ["gb"] });

		autocomplete.addListener("place_changed", function () {
			const place = autocomplete.getPlace();
			if (place.geometry) {
				const lat = place.geometry.location.lat();
				const lng = place.geometry.location.lng();
				search_lat_lon(lat, lng);
				map.setCenter(place.geometry.location);
			}
		});

		// Determine initial search from URL
		if (url_lat && url_lon) {
			search_lat_lon(url_lat, url_lon);
			reverseGeocode(url_lat, url_lon);
		} else if (url_place && url_place !== "undefined") {
			search_place(url_place);
			$("#church_search").val(url_place);
		} else if (url_name && url_name !== "undefined") {
			search_name(url_name);
			$("#church_search").val(url_name);
		} else if (url_search && url_search !== "undefined") {
			// New unified param
			$("#church_search").val(url_search);
			dispatchSearch(url_search);
		} else {
			search_all();
		}

		// --- Search functions ---

		function searchLoader(option) {
			if (option === "start") {
				$(".church-finder-map-container").addClass("searching");
			} else {
				$(".church-finder-map-container").removeClass("searching");
			}
		}

		function dispatchSearch(query) {
			if (!query || query.length < 2) {
				search_all();
				return;
			}
			if (isValidPostcode(query)) {
				search_place(query);
			} else {
				search_name(query);
			}
		}

		function search_name(name) {
			if (!name) return;
			name = name.replace(/\+/g, " ");
			search_url = "?search=" + encodeURIComponent(name);
			if (xhr && xhr.readyState !== 4) xhr.abort();

			xhr = $.ajax({
				type: "GET",
				url: "/actions/church-search/search/search-name",
				dataType: "json",
				data: { name: name },
				beforeSend: function () {
					searchLoader("start");
					if (!$("body").hasClass("devmode-true")) {
						sendEvent("event", undefined, "church_search", "name", encodeURIComponent(name), true);
					}
				},
				success: function (data) {
					process_search(data, "name");
					searchLoader("end");
				},
			});
		}

		function search_place(place) {
			if (!place) return;
			search_url = "?search=" + encodeURIComponent(place);
			if (xhr && xhr.readyState !== 4) xhr.abort();

			xhr = $.ajax({
				type: "GET",
				url: "/actions/church-search/search/search-place",
				dataType: "json",
				data: { place: place },
				beforeSend: function () {
					searchLoader("start");
					if (!$("body").hasClass("devmode-true")) {
						sendEvent("event", undefined, "church_search", "place", encodeURIComponent(place), true);
					}
				},
				success: function (data) {
					process_search(data, "place");
					searchLoader("end");
				},
			});
		}

		function search_lat_lon(lat, lon) {
			if (!lat || !lon) return;
			search_url = "?search_lat=" + encodeURIComponent(lat) + "&search_lon=" + encodeURIComponent(lon);
			if (xhr && xhr.readyState !== 4) xhr.abort();

			xhr = $.ajax({
				type: "GET",
				url: "/actions/church-search/search/search-location",
				dataType: "json",
				data: { lat: lat, lon: lon },
				beforeSend: function () {
					searchLoader("start");
					if (!$("body").hasClass("devmode-true")) {
						sendEvent("event", undefined, "church_search", "latlon", encodeURIComponent(lat + "," + lon), true);
					}
				},
				success: function (data) {
					process_search(data, "place");
					searchLoader("end");
				},
			});
		}

		function search_all() {
			$(".search-sidebar").addClass("hidden");
			$("#church_search").val("");
			search_url = "";
			if (xhr && xhr.readyState !== 4) xhr.abort();

			xhr = $.ajax({
				type: "GET",
				url: "/actions/church-search/search/search-all",
				dataType: "json",
				beforeSend: function () {
					searchLoader("start");
				},
				success: function (data) {
					process_search(data, "all");
					searchLoader("end");
				},
			});
		}

		// --- Process results ---

		function process_search(data, type) {
			if (!data || !type) return;

			window.history.replaceState({}, document.title, "/churches" + search_url);

			if (data.length === 0) {
				$(".church-finder-map-container").addClass("hidden");
				$(".no-results").removeClass("hidden");
				$(".search-sidebar").addClass("hidden");
				return;
			}

			$(".church-finder-map-container").removeClass("hidden");
			$(".no-results").addClass("hidden");

			const newmarkers = [];
			newlistings = [];

			$.each(data, function (i, val) {
				const latitude = val.actual_latitude || val.latitude;
				const longitude = val.actual_longitude || val.longitude;

				newmarkers.push({
					lat: latitude,
					lng: longitude,
					name: val.name,
					membership_num: val.membershipID,
					church_slug: val.slug,
				});

				val.address =
					(val.address1 ? val.address1 + ", " : "") +
					(val.address2 ? val.address2 + ", " : "") +
					(val.address3 ? val.address3 + ", " : "") +
					(val.town ? val.town + ", " : "") +
					(val.county ? val.county + ", " : "") +
					(val.postcode || "");

				newlistings.push(val);
			});

			if (type !== "all") {
				updateSidebar(newlistings);
			}
			updateMarkers(newmarkers);

			if (type !== "all") {
				scrollToMap();
			}
		}

		// --- Sidebar ---

		function updateSidebar(listings) {
			if (!listings) return;

			$(".search-sidebar").removeClass("hidden");
			const results_container = $(".results");
			results_container.empty();

			$.each(listings, function (i, val) {
				let html = $(".sidebar-template").html();
				html = html.replace("[marker_id]", i);
				html = html.replace("[membership_num]", val.membershipID);
				html = html.replace("[name]", val.name);
				html = html.replace("[address]", val.address);

				// Distance
				if (val.distance) {
					const dist = parseFloat(val.distance).toFixed(2);
					html = html.replace(
						"[distance]",
						'<p class="flex items-start"><i class="far fa-route text-primary-200 mr-2 mt-0.5 flex-shrink-0"></i><span>' + dist + " miles</span></p>"
					);
				} else {
					html = html.replace("[distance]", "");
				}

				// Expanded details
				html = html.replace(
					"[extra_mem_num]",
					'<p class="flex items-start"><i class="far fa-id-card text-primary-200 mr-2 mt-0.5 flex-shrink-0"></i><span>Membership: ' + val.membershipID + "</span></p>"
				);

				html = html.replace(
					"[go_to_profile]",
					'<p class="mt-2"><a class="font-bold text-primary-200 hover:text-primary-100 transition" href="/churches/' + val.slug + '">Go to church profile &rarr;</a></p>'
				);

				if (val.denomination) {
					html = html.replace(
						"[extra_denomination]",
						'<p class="flex items-start"><i class="far fa-church text-primary-200 mr-2 mt-0.5 flex-shrink-0"></i><span>' + val.denomination + "</span></p>"
					);
				} else {
					html = html.replace("[extra_denomination]", "");
				}

				const http_link = isValidHttpUrl(val.website) ? val.website : "http://" + val.website;
				if (val.website) {
					html = html.replace(
						"[extra_website]",
						'<p class="flex items-start"><i class="fas fa-globe text-primary-200 mr-2 mt-0.5 flex-shrink-0"></i><a href="' + http_link + '" target="_blank" rel="noopener noreferrer" class="text-primary-200 hover:underline truncate">' + val.website + "</a></p>"
					);
				} else {
					html = html.replace("[extra_website]", "");
				}

				if (val.phone) {
					html = html.replace(
						"[extra_tel]",
						'<p class="flex items-start"><i class="far fa-phone text-primary-200 mr-2 mt-0.5 flex-shrink-0"></i><span>' + val.phone + "</span></p>"
					);
				} else {
					html = html.replace("[extra_tel]", "");
				}

				results_container.append(html);
			});
		}

		// --- Sidebar click ---

		$(document).on("click", ".results .church", function () {
			$(".extra-details").addClass("hidden");
			$(".results .church").removeClass("bg-gray-50");
			$(".results .church .more-details").removeClass("rotate-180");

			if ($(this).hasClass("expanded")) {
				map.setCenter(previousCenterCoords);
				map.setZoom(previousZoomLevel);
				resetMarkers();
				$(this).removeClass("expanded");
			} else {
				$(".results .church").removeClass("expanded");
				$(this).addClass("bg-gray-50 expanded");
				$(this).find(".more-details").addClass("rotate-180");
				$(this).find(".extra-details").removeClass("hidden");

				const membership_num = $(this).attr("data-membership-num");
				const marker_id = $(this).attr("data-marker-id");
				const marker = global_markers_data[marker_id].marker;
				expandChurch(membership_num, marker, false);
			}
		});

		// --- Marker functions ---

		function resetMarkers() {
			for (let i = 0; i < global_markers_data.length; i++) {
				global_markers_data[i].marker.setZIndex(1);
				global_markers_data[i].marker.setIcon(search_icon);
			}
		}

		function highlightMarker(marker) {
			if (typeof marker.marker !== "undefined") {
				marker = marker.marker;
			}
			if (infowindow) {
				infowindow.close();
			}

			resetMarkers();
			marker.setIcon(search_icon_hover);
			marker.setZIndex(50);

			previousCenterCoords = centerCoords;
			previousZoomLevel = zoomLevel;
			map.setZoom(14);
			map.setCenter(marker.position);
		}

		function isValidHttpUrl(string) {
			try {
				const url = new URL(string);
				return url.protocol === "http:" || url.protocol === "https:";
			} catch (_) {
				return false;
			}
		}

		function setMarkers(markers) {
			global_markers.length = 0;
			global_markers_data.length = 0;

			markers.forEach((pos, i) => {
				const mem_number = pos.membership_num;
				const position = new google.maps.LatLng(pos.lat, pos.lng);
				const church = newlistings[i];

				let contentString =
					'<div id="content" class="font-sans-primary">' +
					'<h1 class="font-bold font-sans-secondary text-primary-400 border-b-3 text-lg sm:text-2xl">' +
					church.name +
					"</h1>" +
					'<div class="text-sm"><p>';

				if (church.address) {
					contentString += '<i class="far fa-map-marked-alt text-primary-400 mr-2 mt-2"></i> ' + church.address + "<br>";
				}
				if (church.membershipID) {
					contentString += '<i class="far fa-id-card text-primary-400 mr-2 mt-2"></i> ' + church.membershipID + "<br>";
				}
				if (church.website) {
					const link = isValidHttpUrl(church.website) ? church.website : "http://" + church.website;
					contentString += '<i class="fas fa-globe text-primary-400 mr-2 mt-2"></i><a href="' + link + '" target="_blank" rel="noopener noreferrer">' + church.website + "</a><br>";
				}
				if (church.phone) {
					contentString += '<i class="far fa-phone text-primary-400 mr-2 mt-2"></i>' + church.phone + "<br>";
				}
				if (church.denomination) {
					contentString += '<i class="far fa-church text-primary-400 mr-2 mt-2"></i>' + church.denomination;
				}
				contentString +=
					"</p>" +
					'<p class="my-2 text-right w-full font-bold"><a href="/churches/' + church.slug + '">Go to church profile &rarr;</a></p>' +
					"</div></div>";

				const iw = new google.maps.InfoWindow({ content: contentString });
				infowindows.push(iw);

				const marker = new google.maps.Marker({
					position,
					icon: search_icon,
				});

				global_markers_data[i] = { position, mem_number, marker };

				marker.addListener("click", () => {
					// Close all open infowindows
					for (let j = 0; j < infowindows.length; j++) {
						infowindows[j].close();
					}
					resetMarkers();
					iw.open({ anchor: marker, map });
					highlightMarker(marker);
					$(".results .church").removeClass("selected expanded");
				});

				iw.addListener("closeclick", function () {
					map.setCenter(previousCenterCoords);
					map.setZoom(previousZoomLevel);
					resetMarkers();
				});

				global_markers.push(marker);
			});
		}

		function expandChurch(membership_num, marker, from_marker) {
			highlightMarker(marker);
			$(".results .church").removeClass("selected expanded");
			const church_container = $('.results .church[data-membership-num="' + membership_num + '"]');
			church_container.addClass("selected expanded");
			if (from_marker) {
				const parent_div = $(".search-sidebar");
				parent_div.scrollTop(parent_div.scrollTop() + church_container.position().top);
			}
			scrollToMap();
		}

		function updateMarkers(markers) {
			removeMarkers();
			setMarkers(markers);

			const svg = window.btoa(`
				<svg fill="#2bb2bc" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
				<circle cx="120" cy="120" opacity="1" r="70" />
				<circle cx="120" cy="120" opacity=".7" r="90" />
				<circle cx="120" cy="120" opacity=".3" r="110" />
				<circle cx="120" cy="120" opacity=".2" r="130" />
				</svg>`);

			const renderer = {
				render: ({ count, position }) =>
					new google.maps.Marker({
						label: {
							text: String(count),
							color: "#fff",
							fontFamily: "proxima-nova, sans-serif",
							fontSize: "13px",
							fontWeight: "600",
						},
						icon: {
							url: `data:image/svg+xml;base64,${svg}`,
							scaledSize: new google.maps.Size(45, 45),
						},
						position,
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
					}),
			};

			markerCluster = new markerClusterer.MarkerClusterer({
				markers: global_markers,
				map: map,
				renderer: renderer,
			});

			const bounds = global_markers.reduce(function (b, marker) {
				return b.extend(marker.getPosition());
			}, new google.maps.LatLngBounds());

			map.setCenter(bounds.getCenter());
			if (markers.length > 1) {
				map.fitBounds(bounds);
			} else if (markers.length === 1) {
				const marker = global_markers[0];
				const membership_num = markers[0].membership_num;
				expandChurch(membership_num, marker, false);
			}
		}

		function removeMarkers() {
			if (markerCluster) {
				markerCluster.clearMarkers();
			}
			for (let i = 0; i < global_markers.length; i++) {
				global_markers[i].setMap(null);
			}
			global_markers.length = 0;
			global_markers_data.length = 0;
			infowindows.length = 0;
		}

		function scrollToMap() {
			const target = $(".church-finder-wrapper");
			const offset = target.offset().top;
			$("html, body").animate({ scrollTop: offset }, 600);
		}

		// --- Form submit handler (unified field) ---

		$("#church-search-form").on("submit", function (e) {
			e.preventDefault();
			const query = $("#church_search").val().trim();
			if (xhr && xhr.readyState !== 4) xhr.abort();

			if (query.length === 0) {
				search_all();
			} else if (query.length >= 2) {
				dispatchSearch(query);
			}
			return false;
		});

		// --- View all link ---

		$(".view-all-churches").on("click", function (e) {
			e.preventDefault();
			search_all();
			scrollToMap();
		});

		// --- Geolocation ---

		$(document).ready(function () {
			if (navigator.geolocation) {
				$(document).on("click", ".get-location", function () {
					navigator.geolocation.getCurrentPosition(
						function (position) {
							const marker = new google.maps.Marker({
								position: new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
								draggable: false,
								icon: {
									path: google.maps.SymbolPath.CIRCLE,
									fillColor: "#459bea",
									fillOpacity: 1,
									scale: 11,
									strokeWeight: 0,
								},
							});
							marker.setMap(map);
							search_lat_lon(position.coords.latitude, position.coords.longitude);
							reverseGeocode(position.coords.latitude, position.coords.longitude);
						},
						function () {
							alert("There was a problem finding your location");
						}
					);
				});
			}
		});

		// --- Reverse geocode (fills the search input with a place name) ---

		function reverseGeocode(lat, lon) {
			const geocoder = new google.maps.Geocoder();
			geocoder.geocode({ location: { lat, lng: lon } }, function (results, status) {
				if (status === "OK" && results[0]) {
					$("#church_search").val(results[0].formatted_address);
				}
			});
		}
	}

	initMap();
})(jQuery);